import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import { Directive, OnInit, Input, ElementRef } from '@angular/core';

@Directive({
  selector: '[barcode]',
})
export class BarcodeDirective implements OnInit {
  @Input() val2D: string;
  @Input() val3D: string;

  constructor(private e: ElementRef<HTMLImageElement>) {}

  ngOnInit() {
    if (this.val2D) {
      this.e.nativeElement.setAttribute('data-value', this.val2D);
      this.e.nativeElement.setAttribute('data-displayvalue', 'false');
      this.e.nativeElement.setAttribute('data-margin', '0');
      JsBarcode(this.e.nativeElement).init();
    }
    if (this.val3D) {
      QRCode.toDataURL(this.val3D, { scale: 2 }, (e, u) => {
        if (e) {
          console.log(e);
        } else {
          this.e.nativeElement.src = u;
        }
      });
    }
  }
}
